import React, { Suspense } from 'react';
const CodeScanner = /*#__PURE__*/React.lazy(() => import("./CodeScanner.js"));
export default function LazyCodeScanner({
  fallback,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: fallback || 'Loading...'
  }, /*#__PURE__*/React.createElement(CodeScanner, props));
}